webpackJsonp(["conditioner8"],{

/***/ "./src/js/ui/carousel.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = carousel;
function carousel($carousel) {
  init($carousel);
}

function init($carousel) {
  var preventClick = false;

  var $container = $carousel.closest('.js-carousel-container');

  var carouselOptions = {
    cellAlign: 'center',
    contain: true,
    prevNextButtons: false,
    wrapAround: false,
    imagesLoaded: true
  };

  switch ($carousel.getAttribute('data-carousel-type')) {
    case 'dots':
      carouselOptions.pageDots = true;
      break;
    case 'prevNext':
    default:
      carouselOptions.pageDots = false;
      break;
  }

  __webpack_require__.e/* import() */("flickity").then(__webpack_require__.bind(null, "./node_modules/flickity-imagesloaded/flickity-imagesloaded.js")).then(function (Flickity) {
    var flkty = new Flickity($carousel, carouselOptions);

    flkty.on('staticClick', function (e, pointer, element, index) {
      if (index !== flkty.selectedIndex) {
        preventClick = true;
        window.setTimeout(function () {
          preventClick = false;
        }, 0);
        flkty.select(index);
      }
    });

    $carousel.addEventListener('click', function (e) {
      var $link = e.target.closest('a');
      if (!$link) return;
      if (preventClick) {
        e.preventDefault();
      }
    });

    var $prev = $container.querySelector('.js-carousel-prev');
    if ($prev) {
      $prev.addEventListener('click', function (e) {
        flkty.previous();
      });
    }
    var $next = $container.querySelector('.js-carousel-next');
    if ($next) {
      $container.querySelector('.js-carousel-next').addEventListener('click', function (e) {
        flkty.next();
      });
    }
  });
}

/***/ })

});


// WEBPACK FOOTER //
// conditioner8.f3aa35059157f77275bf.js